<template>
  <v-flex>
    <v-snackbar
      v-for="notification in notifications"
      :key="notification.id"
      :timeout="notification.timeout"
      :color="notification.type"
      top
      right
      @input="removeNotification(notification)"
      :value="true"
    >
      <span class="notification-message">
        {{ notification.message }}
      </span>
      <v-btn
        icon
        dark
        @click.native="removeNotification(notification)"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-flex>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import SnackbarNotificationConstants from '@/store/modules/snackbarNotification/constants';

export default {
  name: 'snackbarNotification',
  computed: mapState({
    notifications: (state) => state.snackbarNotification.stack,
  }),
  methods: mapActions(
    'snackbarNotification',
    {
      removeNotification: SnackbarNotificationConstants.actionTypes.remove,
    },
  ),
};
</script>

<style scoped lang="scss">
  .notification-message{
    word-break: break-all;
  }
</style>
